module.exports = __webpack_public_path__ + "static/media/main-girl-mobile.3c5516f1.png";